var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgConversations = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 80,
  height: 80,
  fill: "none",
  viewBox: "0 0 84 85"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 42,
  cy: 42.987,
  r: 42,
  fill: "#242427"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__a)",
  d: "m55.14 61.427-5.955-41.528a5.96 5.96 0 0 0-6.746-5.053L18.9 18.22a5.96 5.96 0 0 0-5.053 6.746l5.955 41.527a5.96 5.96 0 0 0 6.745 5.054l23.54-3.376a5.96 5.96 0 0 0 5.054-6.745Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__b)",
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "m56.13 61.285-5.955-41.527a6.96 6.96 0 0 0-7.878-5.902l-23.54 3.376a6.96 6.96 0 0 0-5.9 7.877l5.954 41.527a6.96 6.96 0 0 0 7.877 5.902l23.54-3.376a6.96 6.96 0 0 0 5.902-7.877Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__c)",
  d: "m41.587 16.538-21.394 3.068a5.11 5.11 0 0 0-4.333 5.784l5.755 40.134a5.11 5.11 0 0 0 5.784 4.332l21.394-3.067a5.11 5.11 0 0 0 4.333-5.784L47.37 20.871a5.11 5.11 0 0 0-5.784-4.333Z"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__d)",
  d: "m17.158 48.066 2.643 18.429a5.96 5.96 0 0 0 6.745 5.053l23.54-3.375a5.96 5.96 0 0 0 5.054-6.746L52.497 43l-35.339 5.067Z"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__e)",
  d: "m40.827 68.345-5.346.767a1.825 1.825 0 1 1-.518-3.614l5.346-.766a1.825 1.825 0 1 1 .518 3.613Z"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__f)",
  d: "m42.44 14.846-14.084 2.02 7.646 53.326 14.085-2.02a5.96 5.96 0 0 0 5.053-6.745L49.185 19.9a5.96 5.96 0 0 0-6.745-5.054Z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__g)",
  d: "m45.82 22.704 4.936 34.42a4.983 4.983 0 0 1-4.226 5.64l-18.09 2.594a4.983 4.983 0 0 1-5.64-4.226l-4.936-34.42a4.983 4.983 0 0 1 4.225-5.64l3.023-.433a.92.92 0 0 1 1.04.78.92.92 0 0 0 1.041.78l8.405-1.206a.92.92 0 0 0 .78-1.04.92.92 0 0 1 .78-1.041l3.022-.434a4.983 4.983 0 0 1 5.64 4.226Z"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__h)",
  d: "m40.18 18.478-3.023.434a.92.92 0 0 0-.78 1.04.92.92 0 0 1-.78 1.041L27.194 22.2a.92.92 0 0 1-1.04-.78.92.92 0 0 0-1.041-.78l-3.023.433a4.983 4.983 0 0 0-4.225 5.64l1.814 12.652 27.956-4.01-1.814-12.65a4.983 4.983 0 0 0-5.64-4.226Z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__i)",
  d: "m30.573 21.714-3.38.485a.92.92 0 0 1-1.04-.78.92.92 0 0 0-1.041-.78l-3.023.433a4.983 4.983 0 0 0-4.225 5.64l4.935 34.42a4.983 4.983 0 0 0 5.64 4.226l8.223-1.18-6.089-42.464Z"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__j)",
  d: "m36.781 46.721-4.003 5.345L46.95 62.684a4.983 4.983 0 0 0 3.804-5.56l-1.743-12.156-12.23 1.753Z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  stroke: "#EDCFFF",
  strokeWidth: 2,
  d: "M53.468 26.49h-1.151l.16 1.14 2.962 21 .121.86h6.716a8.75 8.75 0 0 0 8.75-8.751V35.24a8.751 8.751 0 0 0-8.75-8.751h-8.808Z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__k)",
  d: "M32.644 27.49h29.633c4.28 0 7.75 3.47 7.75 7.75v5.499a7.75 7.75 0 0 1-7.75 7.75H37.108a.298.298 0 0 0-.257.152c-.866 1.492-2.669 2.554-5.036 3.166-.293.076-.49-.289-.27-.497.884-.845 1.318-1.679 1.391-2.496a.296.296 0 0 0-.293-.324 7.75 7.75 0 0 1-7.751-7.751V35.24c0-4.281 3.47-7.751 7.75-7.751Z"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__l)",
  d: "M70.028 35.24v5.499a7.75 7.75 0 0 1-7.75 7.75h-6.45v-21h6.45a7.75 7.75 0 0 1 7.75 7.751Z"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__m)",
  d: "M24.893 35.368v5.37a7.75 7.75 0 0 0 7.75 7.752c.175 0 .31.15.294.325-.073.816-.508 1.65-1.392 2.495-.219.209-.022.573.27.497 2.368-.611 4.171-1.674 5.037-3.166a.298.298 0 0 1 .257-.151h25.167a7.75 7.75 0 0 0 7.752-7.751v-5.37H24.893Z"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__n)",
  d: "m34.598 42.852 2.42.758a1.012 1.012 0 0 0 1.314-.955l.027-2.536c.003-.206.068-.407.187-.575l1.469-2.068a1.012 1.012 0 0 0-.502-1.544l-2.404-.81a1.012 1.012 0 0 1-.489-.355l-1.512-2.036a1.012 1.012 0 0 0-1.625 0l-1.512 2.036c-.123.165-.294.29-.49.355l-2.403.81a1.012 1.012 0 0 0-.502 1.544l1.469 2.068c.12.168.184.37.186.575l.028 2.536a1.012 1.012 0 0 0 1.314.955l2.42-.758c.197-.061.408-.061.605 0Z"
})), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__o)",
  d: "M28.49 36.45c-.152.317-.14.708.086 1.025l1.468 2.068c.12.168.185.369.187.575l.028 2.536a1.012 1.012 0 0 0 1.314.955l2.42-.758a1.01 1.01 0 0 1 .605 0l2.42.758a1.012 1.012 0 0 0 1.314-.955l.027-2.536c.001-.1.017-.197.047-.29L28.49 36.45Z"
})), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__p)",
  d: "M40.102 36.45c.152.317.14.708-.087 1.025l-1.468 2.068c-.12.168-.185.369-.187.575l-.027 2.536a1.012 1.012 0 0 1-1.314.955l-2.42-.758a1.01 1.01 0 0 0-.605 0l-2.42.758a1.012 1.012 0 0 1-1.315-.955l-.027-2.536a1.006 1.006 0 0 0-.046-.29l9.916-3.378Z"
})), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__q)",
  d: "m39.514 35.932-2.404-.81a1.012 1.012 0 0 1-.49-.355l-1.512-2.036a1.006 1.006 0 0 0-.812-.408v10.483c.102 0 .204.016.302.046l2.42.758a1.012 1.012 0 0 0 1.315-.955l.027-2.536c.002-.206.067-.407.187-.575l1.468-2.067a1.012 1.012 0 0 0-.502-1.545Z"
})), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__r)",
  d: "m39.514 35.932-2.404-.81a1.012 1.012 0 0 1-.49-.355l-1.512-2.036a1.006 1.006 0 0 0-.812-.408v10.483c.102 0 .204.016.302.046l2.42.758a1.012 1.012 0 0 0 1.315-.955l.027-2.536c.002-.206.067-.407.187-.575l1.468-2.067a1.012 1.012 0 0 0-.502-1.545Z"
})), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__s)",
  d: "M30.19 39.843c.026.09.04.182.041.275l.028 2.537a1.012 1.012 0 0 0 1.314.954l2.42-.758a1.01 1.01 0 0 1 .605 0l2.42.758a1.012 1.012 0 0 0 1.314-.954l.027-2.537c.001-.093.016-.186.042-.275H30.19Z"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__t)",
  d: "m34.468 40.787 1.393.436a.582.582 0 0 0 .756-.55l.016-1.458a.584.584 0 0 1 .107-.331l.845-1.19a.582.582 0 0 0-.289-.888l-1.383-.466a.582.582 0 0 1-.281-.205l-.87-1.17a.582.582 0 0 0-.935 0l-.87 1.17a.582.582 0 0 1-.281.205l-1.383.466a.582.582 0 0 0-.289.888l.845 1.19a.582.582 0 0 1 .108.33l.015 1.46c.005.39.384.666.756.55l1.393-.437a.583.583 0 0 1 .347 0Z"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__u)",
  d: "m47.76 42.852 2.421.758a1.012 1.012 0 0 0 1.314-.955l.028-2.536c.002-.206.067-.407.186-.575l1.47-2.068a1.012 1.012 0 0 0-.503-1.544l-2.404-.81a1.012 1.012 0 0 1-.489-.355l-1.512-2.036a1.012 1.012 0 0 0-1.624 0l-1.513 2.036c-.123.165-.294.29-.49.355l-2.403.81a1.012 1.012 0 0 0-.502 1.544l1.469 2.068c.12.168.184.37.187.575l.027 2.536a1.012 1.012 0 0 0 1.314.955l2.42-.758c.197-.061.408-.061.605 0Z"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__v)",
  d: "M41.653 36.452c-.152.316-.14.707.086 1.025l1.469 2.068c.119.168.184.368.186.575l.028 2.536a1.012 1.012 0 0 0 1.314.954l2.42-.757c.197-.062.408-.062.605 0l2.42.757a1.012 1.012 0 0 0 1.314-.954l.027-2.536c.001-.1.017-.198.047-.291l-9.916-3.377Z"
})), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__w)",
  d: "M53.265 36.452c.152.316.14.707-.087 1.025l-1.468 2.068c-.12.168-.185.368-.187.575l-.027 2.536a1.012 1.012 0 0 1-1.314.954l-2.42-.757a1.012 1.012 0 0 0-.605 0l-2.42.757a1.012 1.012 0 0 1-1.315-.954l-.027-2.536a1.007 1.007 0 0 0-.046-.291l9.916-3.377Z"
})), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__x)",
  d: "m52.677 35.932-2.404-.81a1.012 1.012 0 0 1-.49-.355l-1.512-2.036a1.006 1.006 0 0 0-.812-.408v10.483c.102 0 .204.016.302.046l2.42.758a1.012 1.012 0 0 0 1.315-.955l.027-2.536c.002-.206.067-.407.187-.575l1.468-2.067a1.012 1.012 0 0 0-.501-1.545Z"
})), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__y)",
  d: "m52.677 35.932-2.404-.81a1.012 1.012 0 0 1-.49-.355l-1.512-2.036a1.006 1.006 0 0 0-.812-.408v10.483c.102 0 .204.016.302.046l2.42.758a1.012 1.012 0 0 0 1.315-.955l.027-2.536c.002-.206.067-.407.187-.575l1.468-2.067a1.012 1.012 0 0 0-.501-1.545Z"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__z)",
  d: "M43.352 39.844c.026.089.04.181.041.275l.028 2.536a1.012 1.012 0 0 0 1.314.955l2.42-.758a1.01 1.01 0 0 1 .605 0l2.42.758a1.012 1.012 0 0 0 1.314-.955l.027-2.536c.001-.094.016-.186.042-.275h-8.211Z"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__A)",
  d: "m47.632 40.788 1.392.436a.582.582 0 0 0 .756-.55l.016-1.459a.583.583 0 0 1 .107-.33l.845-1.19a.582.582 0 0 0-.289-.889l-1.383-.465a.582.582 0 0 1-.28-.205l-.871-1.171a.582.582 0 0 0-.934 0l-.87 1.171a.583.583 0 0 1-.282.204l-1.383.466a.582.582 0 0 0-.289.889l.845 1.19a.582.582 0 0 1 .108.33l.015 1.46c.005.39.384.665.756.549l1.393-.436a.583.583 0 0 1 .348 0Z"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__B)",
  d: "m60.926 42.853 2.42.758a1.012 1.012 0 0 0 1.314-.955l.028-2.536c.002-.206.067-.407.186-.575l1.47-2.068a1.012 1.012 0 0 0-.503-1.545l-2.403-.81a1.012 1.012 0 0 1-.49-.355l-1.512-2.036a1.012 1.012 0 0 0-1.624 0l-1.513 2.036c-.123.166-.294.29-.49.356l-2.403.81a1.012 1.012 0 0 0-.502 1.544l1.469 2.068c.12.168.184.369.187.575l.027 2.536a1.012 1.012 0 0 0 1.314.955l2.42-.758c.197-.062.408-.062.605 0Z"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__C)",
  d: "M54.818 36.452c-.152.316-.14.707.086 1.025l1.469 2.068c.119.168.184.368.186.575l.028 2.536a1.012 1.012 0 0 0 1.314.954l2.42-.757c.197-.062.408-.062.605 0l2.42.757a1.012 1.012 0 0 0 1.314-.954l.027-2.536c.001-.1.017-.198.047-.291l-9.916-3.377Z"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__D)",
  d: "M66.43 36.452c.152.316.14.707-.087 1.025l-1.468 2.068c-.12.168-.185.368-.187.575l-.027 2.536a1.012 1.012 0 0 1-1.314.954l-2.42-.757a1.012 1.012 0 0 0-.605 0l-2.42.757a1.012 1.012 0 0 1-1.315-.954l-.027-2.536a1.014 1.014 0 0 0-.046-.291l9.916-3.377Z"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__E)",
  d: "m65.842 35.932-2.404-.81a1.012 1.012 0 0 1-.49-.355l-1.512-2.036a1.006 1.006 0 0 0-.812-.408v10.484c.102 0 .204.015.302.046l2.42.758a1.012 1.012 0 0 0 1.315-.955l.027-2.536c.002-.206.067-.407.187-.575l1.468-2.068a1.012 1.012 0 0 0-.501-1.545Z"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__F)",
  d: "m65.842 35.932-2.404-.81a1.012 1.012 0 0 1-.49-.355l-1.512-2.036a1.006 1.006 0 0 0-.812-.408v10.484c.102 0 .204.015.302.046l2.42.758a1.012 1.012 0 0 0 1.315-.955l.027-2.536c.002-.206.067-.407.187-.575l1.468-2.068a1.012 1.012 0 0 0-.501-1.545Z"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__G)",
  d: "M56.517 39.844c.026.09.04.182.041.275l.028 2.537a1.012 1.012 0 0 0 1.314.954l2.42-.758c.197-.061.408-.061.605 0l2.42.758a1.012 1.012 0 0 0 1.314-.954l.027-2.537c.001-.093.016-.186.042-.275h-8.211Z"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#conversations_svg__H)",
  d: "m60.797 40.788 1.392.436a.582.582 0 0 0 .756-.55l.016-1.459a.584.584 0 0 1 .107-.33l.845-1.19a.582.582 0 0 0-.289-.889l-1.383-.465a.582.582 0 0 1-.28-.205l-.871-1.171a.582.582 0 0 0-.934 0l-.87 1.171a.583.583 0 0 1-.282.204l-1.383.466a.582.582 0 0 0-.289.889l.845 1.19a.581.581 0 0 1 .108.33l.015 1.46c.005.39.384.665.756.549l1.393-.436a.583.583 0 0 1 .348 0Z"
})), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__a",
  x1: 10.613,
  x2: 53.758,
  y1: 37.711,
  y2: 47.622,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B55CFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__b",
  x1: 10.613,
  x2: 53.758,
  y1: 37.711,
  y2: 47.622,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#B55CFD"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__c",
  x1: 55.865,
  x2: 15.411,
  y1: 41.384,
  y2: 44.816,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5200FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#854DFC"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__d",
  x1: 37.789,
  x2: 38.254,
  y1: 66.183,
  y2: 69.426,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__e",
  x1: 38.182,
  x2: 37.748,
  y1: 68.926,
  y2: 65.9,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B55CFD"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#9039FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__f",
  x1: 47.944,
  x2: 51.971,
  y1: 41.268,
  y2: 40.691,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#5548F3",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#5548F3"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__g",
  x1: 19.918,
  x2: 47.806,
  y1: 34.71,
  y2: 48.678,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#F5FBFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#D8ECFE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__h",
  x1: 31.915,
  x2: 31.212,
  y1: 25.22,
  y2: 20.318,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3DAFE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.431,
  stopColor: "#B1D9FE",
  stopOpacity: 0.432
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.666,
  stopColor: "#A9D6FE",
  stopOpacity: 0.666
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#9BD0FE",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__i",
  x1: 30.146,
  x2: 20.568,
  y1: 42.515,
  y2: 43.888,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3DAFE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.431,
  stopColor: "#B1D9FE",
  stopOpacity: 0.432
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.666,
  stopColor: "#A9D6FE",
  stopOpacity: 0.666
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#9BD0FE",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__j",
  x1: 50.984,
  x2: 39.472,
  y1: 61.912,
  y2: 46.627,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#B3DAFE",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.431,
  stopColor: "#B1D9FE",
  stopOpacity: 0.432
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.666,
  stopColor: "#A9D6FE",
  stopOpacity: 0.666
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.852,
  stopColor: "#9BD0FE",
  stopOpacity: 0.852
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#8AC9FE"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__k",
  x1: 41.278,
  x2: 52.385,
  y1: 25.626,
  y2: 47.84,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FFA1AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__l",
  x1: 65.017,
  x2: 70.08,
  y1: 37.989,
  y2: 37.989,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.234,
  stopColor: "#7000FF",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.517,
  stopColor: "#7000FF",
  stopOpacity: 0.51
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.824,
  stopColor: "#7000FF",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__m",
  x1: 47.46,
  x2: 47.46,
  y1: 42.694,
  y2: 49.294,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#7000FF",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.234,
  stopColor: "#7000FF",
  stopOpacity: 0.23
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.517,
  stopColor: "#7000FF",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.824,
  stopColor: "#7000FF",
  stopOpacity: 0.82
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7000FF"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__n",
  x1: 32.419,
  x2: 38.789,
  y1: 36.955,
  y2: 43.326,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__o",
  x1: 33.496,
  x2: 34.426,
  y1: 39.449,
  y2: 37.263,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__p",
  x1: 35.018,
  x2: 34.495,
  y1: 39.104,
  y2: 37.471,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__q",
  x1: 35.184,
  x2: 33.203,
  y1: 38.011,
  y2: 38.076,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__r",
  x1: 38.082,
  x2: 39.524,
  y1: 38.76,
  y2: 39.225,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__s",
  x1: 34.295,
  x2: 34.295,
  y1: 41.681,
  y2: 43.513,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__t",
  x1: 36.469,
  x2: 30.924,
  y1: 40.649,
  y2: 35.104,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__u",
  x1: 45.582,
  x2: 51.952,
  y1: 36.955,
  y2: 43.326,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__v",
  x1: 46.659,
  x2: 47.59,
  y1: 39.45,
  y2: 37.264,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__w",
  x1: 48.181,
  x2: 47.658,
  y1: 39.105,
  y2: 37.472,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__x",
  x1: 48.347,
  x2: 46.366,
  y1: 38.011,
  y2: 38.076,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__y",
  x1: 51.245,
  x2: 52.687,
  y1: 38.76,
  y2: 39.225,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__z",
  x1: 47.458,
  x2: 47.458,
  y1: 41.681,
  y2: 43.513,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__A",
  x1: 49.632,
  x2: 44.087,
  y1: 40.65,
  y2: 35.105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__B",
  x1: 58.747,
  x2: 65.117,
  y1: 36.956,
  y2: 43.326,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__C",
  x1: 59.824,
  x2: 60.755,
  y1: 39.45,
  y2: 37.264,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__D",
  x1: 61.346,
  x2: 60.824,
  y1: 39.105,
  y2: 37.472,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__E",
  x1: 61.513,
  x2: 59.531,
  y1: 38.011,
  y2: 38.077,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__F",
  x1: 64.41,
  x2: 65.852,
  y1: 38.76,
  y2: 39.225,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__G",
  x1: 60.623,
  x2: 60.623,
  y1: 41.682,
  y2: 43.514,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FE9738",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FE9738"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "conversations_svg__H",
  x1: 62.797,
  x2: 57.252,
  y1: 40.65,
  y2: 35.105,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FEF0AE"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#FAC600"
})))));
export { SvgConversations as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiM2E1NTNiZGE5M2M5MTQzZWYwZGE5NTNjZjRkZGZiODguc3ZnIjs=";